// extracted by mini-css-extract-plugin
module.exports = {"NewPatternConditionBlock":"NewPatternCondition_NewPatternConditionBlock__eMURK"};